import { render } from "./add-validator.vue?vue&type=template&id=d0d5af32"
import script from "./add-validator.vue?vue&type=script&lang=js"
export * from "./add-validator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__